import { useMutation } from '@tanstack/react-query';
import updateTCAPUser from '@/API/TCAPUser/updateTCAPUser';

const useUpdateTCAPUsers = ({
    tcapUserId,
    formData,
    originalData,
    accountScope,
    refetchPlatformUsers,
}) => {
    const shouldUpdate = formData?.id !== originalData?.id;

    return useMutation({
        mutationFn: async () => {
            if (!shouldUpdate) return;

            try {
                const newTCAPPrimaryUser = {
                    id: tcapUserId,
                    primaryUserId: formData?.id,
                };
                await updateTCAPUser(newTCAPPrimaryUser, accountScope);
                refetchPlatformUsers();
            } catch (error) {
                console.error('Error updating TCAP user:', error);
            }
        },
        staleTime: 0,
        enabled: shouldUpdate,
    });
};
export default useUpdateTCAPUsers;
